module.exports = __webpack_public_path__ + "img/dm.3de34614.svg";